import React, { useState, useEffect } from 'react';
import ChildPage from '../components/ChildPage';
import ReusableModal from '../components/ReusableModal';
import { 
  calcModals, 
  showModalContent, 
  hideModalContent 
} from '../helpers/functions';
import BgImage from '../assets/MWC-Services_Start.jpg';
import VideoTransitionIn from '../assets/Transition_Start-Factory.mp4';
import VideoBgLoop from '../assets/factory/Factory_Bg-Loop.mp4';
import VideoTransitionOut from '../assets/Transition_Back-Start.mp4';
import ModalOneSrc from '../assets/factory/Factory_Services-PreStaging.mp4';
import ModalTwoSrc from '../assets/factory/Factory_Factory-Integration.mp4';
import ModalThreeSrc from '../assets/factory/Factory_Customer-Story-Telecomms-Comp.jpg';

export default function Factory() {
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);

  useEffect(() => {
    // listeners
    window.addEventListener('resize', calcModals);
  }, []);
  
  return (
    <>
      <ChildPage
        BgImage={BgImage}
        VideoTransitionIn={VideoTransitionIn}
        VideoBgLoop={VideoBgLoop}
        VideoTransitionOut={VideoTransitionOut}
      >
        <button onClick={() => setShow1(true)}>
          <div className="position-absolute" style={{width: 12.8 + '%', height: 4 + '%', bottom: 21.4 + '%', left: 63.8 + '%'}}></div>
        </button>
        <ReusableModal
          show={show1}
          handleClose={() => setShow1(false)}
          handleShow={() => setShow1(true)}
          size="xl"
          onEnter={calcModals}
          onEntered={showModalContent}
          onExit={hideModalContent}
        >
          <video 
            src={ModalOneSrc} 
            type="video/mp4" 
            className="w-100" 
            loop
            muted
          />
        </ReusableModal>

        <button onClick={() => setShow2(true)}>
          <div className="position-absolute" style={{width: 18.2 + '%', height: 4 + '%', bottom: 16.8 + '%', left: 63.8 + '%'}}></div>
        </button>
        <ReusableModal
          show={show2}
          handleClose={() => setShow2(false)}
          handleShow={() => setShow2(true)}
          size="xl"
          onEnter={calcModals}
          onEntered={showModalContent}
          onExit={hideModalContent}
        >
          <video 
            src={ModalTwoSrc} 
            type="video/mp4" 
            className="w-100" 
            loop
            muted
          />
        </ReusableModal>

        <button onClick={() => setShow3(true)}>
          <div className="position-absolute" style={{width: 15.8 + '%', height: 4 + '%', bottom: 12.1 + '%', left: 63.8 + '%'}}></div>
        </button>
        <ReusableModal
          show={show3}
          handleClose={() => setShow3(false)}
          handleShow={() => setShow3(true)}
          size="xl"
          onEnter={calcModals}
          onEntered={showModalContent}
          onExit={hideModalContent}
        >
          <img 
            src={ModalThreeSrc} 
            alt="home" 
            className="w-100"
          />
        </ReusableModal>
      </ChildPage>
    </>
  )
}
